/**
 * 配置项目权限
 * 2: 专家权限
 * 3: 管理员权限
 */
export const ProjectPermissions = 3;

/**
 * 接口配置
 */
export const PortConfig = {
  // 线上地址
  baseURL: "https://pro.arteamview.agrtc.cn/arapi/v1",
  // baseURL: "https://arteamview.agrtc.cn/arapi/v1",
  timeout: 30000,
  withCredentials: true,
};

/**
 * loading 显示配置
 */
// 黑名单(不显示 loading)接口
export const BlankloadingPort = [
  "/teamview/insertUserOnlineInfo",
  "/teamview/joinRoom",
  "/teamview/leaveRoom",
  "/teamview/getSpecialist",
  "/teamview/getUserInfo",
];
